module.exports = __webpack_public_path__ + "media/images/common/new_entry_btn_ov-e40af0bd318a6f976888aaaf4099a09f.png";